import zod from 'zod';

export const productListDataSchema = zod.object({
  products: zod.object({
    media_applications: zod.array(
      zod.object({
        id: zod.string(),
      })
    ),
    programmable_media: zod.array(
      zod.object({
        id: zod.string(),
      })
    ),
  }),
});

export type ProductListDataSchema = ReturnType<typeof productListDataSchema.parse>;

export type FetchProductListData = (customerExternalId: string) => Promise<ProductListDataSchema>;
